import Vue from 'vue'
// import Vue from 'vue/dist/vue.js';
import VueRouter from 'vue-router'
import App from './App.vue'
import MainLayout from './layout/Main.vue'
import Pokemon from "./Pokemon";
import Cyphers from "./Cyphers";
import './registerServiceWorker'
// import svgJs from "./plugins/svgplugin"

/*eslint no-unused-vars: ["error", { "vars": "local" }]*/

Vue.component('v-select', require('vue-select'));
Vue.use(VueRouter);
// Vue.use(svgJs);
// (function() {
//     if('serviceWorker' in navigator) {
//         navigator.serviceWorker.register('/service-worker.js');
//     }
// })();
const pokeRouter = new VueRouter({
    mode: 'history',
    routes: [
        {path: '/', component: App},
        // {path: '/', component: Pokemon},
        // {path: '/home', component: App},
        {path: '/pokemon', name: 'Pokemon', component: Pokemon, props: (route)=>({query: {...route.query,visibleBack:true}}),},
        {path: '/cypher', name: 'Cyphers', component: Cyphers, props: (route)=>({query: {...route.query,visibleBack:true}}),},
        {path: '/cipher', name: 'Ciphers', component: Cyphers, props: (route)=>({query: {...route.query,visibleBack:true}}),},
    ] // short for `routes: routes`
});

const cypherRouter = new VueRouter({
    mode: 'history',
    routes: [
        {path: '/', component: App},
        // {path: '/', component: Cyphers},
        // {path: '/index.html', component: Cyphers},
        {path: '/pokemon', name: 'Pokemon', component: Pokemon, props: (route)=>({query: {...route.query,visibleBack:true}}),},
        {path: '/cypher', name: 'Cyphers', component: Cyphers, props: (route)=>({query: {...route.query,visibleBack:true}}),},
        {path: '/cipher', name: 'Ciphers', component: Cyphers, props: (route)=>({query: {...route.query,visibleBack:true}}),},
    ] // short for `routes: routes`
});
const host = window.location.host;
const parts = host.split('.');
//eslint-disable-next-line no-unused-vars
const base_url = parts.length!==4 ? parts.slice(-2).join('.') : parts.join('.');

//console.log(base_url);
const domainLength = 3;
const links = {}
let title = "PokemonGo stats"
const router = (data) => {
    let routes;
    //console.log("Subrouting pokemon")
    data['main'] = {}
    data['main']['link'] = '/pokemon'
    data['main']['linkName'] = 'Pokèmon'
    data[ 'sec'] = {}
    data[ 'sec']['link'] = `/cypher`
    data[ 'sec']['linkName'] = 'Šifry'
    if (parts.length === (domainLength - 1) || parts[0] === 'www') {
        routes = pokeRouter;
    }else if(parts.length === 4){
        routes = pokeRouter;
        data['main'] = {};
        data['main']['link'] = `/pokemon`;
        data['main']['linkName'] = 'Pokèmon';
        data[ 'sec'] = {};
        data[ 'sec']['link'] = '/cypher';
        data[ 'sec']['linkName'] = 'Šifry';
    } else if (parts[0] === 'pokemon') {
        routes = pokeRouter;
    } else if (parts[0] === 'cypher') {
        //console.log("Subrouting cypher")
        routes = cypherRouter;
        title = "Šifrovátko"
        data['main'] = {};
        data['main']['link'] = '/cypher';
        data['main']['linkName'] = 'Šifry';
        data[ 'sec'] = {};
        data[ 'sec']['link'] = `/pokemon`;
        data[ 'sec']['linkName'] = 'Pokèmon';
    }else if (parts[0] === 'cipher') {
        //console.log("Subrouting cypher")
        routes = cypherRouter;
        title = "Šifrovátko"
        data['main'] = {};
        data['main']['link'] = '/cypher';
        data['main']['linkName'] = 'Šifry';
        data[ 'sec'] = {};
        data[ 'sec']['link'] = `/pokemon`;
        data[ 'sec']['linkName'] = 'Pokèmon';
    } else {
        // If you want to do something else just comment the line below
        routes = cypherRouter;
        routes = pokeRouter;
    }
    return routes;
};
// HotFix
if(!String.prototype.replaceAll){
    String.prototype.replaceAll = function(search, replacement) {
        var target = this;
        return target.split(search).join(replacement);
    };
}
//
new Vue({
    router: router(links),
    // eslint-disable-next-line no-unused-vars
    components: {MainLayout},
    template: '<main-layout :links="links" :title="title"><router-view></router-view></main-layout>',
    methods:{
      replaceUrlQuery:function (query) {
          this.$router.replace({query});
      }
    },
    data:{
        links: links,
        title: title,
    }
}).$mount('#app');
